import {FormSubmitHandler, showNotification} from 'platform/components';

import {useMyWebAuthenticateMutation} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {useMyWebPlatformResolved} from '../hooks/useMyWebPlatformResolved';
import {PlatformAuthenticationFormData} from './PlatformAuthenticationForm';
import {PlatformAuthenticationFormMyWeb} from './PlatformAuthenticationFormMyWeb';
import {PlatformMyWebDescriptionFormat} from './PlatformMyWebDescriptionFormat';
import {PlatformPhotoSettings} from './PlatformPhotoSettings';

export function PlatformSettingsMyWeb() {
  const {activeData, resolvedParams, isFetching, isError, isPublishingOnTenant} =
    useMyWebPlatformResolved();
  const [saveAuthentication] = useMyWebAuthenticateMutation();

  const onSubmitCredentials: FormSubmitHandler<PlatformAuthenticationFormData> = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({
      body: values,
      params: resolvedParams,
    })
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <>
      <PlatformAuthenticationFormMyWeb
        values={activeData?.credentials}
        isPublishingOnTenant={isPublishingOnTenant}
        isFetching={isFetching}
        isError={isError}
        onSubmit={onSubmitCredentials}
      />
      <PlatformMyWebDescriptionFormat />
      <PlatformPhotoSettings
        platformCode={AdvertisingPlatformCodeEnum.MYWEB}
        isPublishingOnTenant={isPublishingOnTenant}
      />
    </>
  );
}
